var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOutlineCheckTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6049 0.278376C12.7964 -0.00882936 13.1844 -0.0864341 13.4716 0.105036C13.7588 0.296506 13.8364 0.68453 13.645 0.971735L6.14497 12.2217C6.04116 12.3775 5.87302 12.4783 5.6868 12.4968C5.50047 12.5153 5.31546 12.4494 5.18306 12.3169L0.183058 7.31695C-0.0610194 7.07287 -0.0610194 6.67724 0.183058 6.43316C0.427136 6.18908 0.82277 6.18908 1.06685 6.43316L5.5273 10.8936L12.6049 0.278376Z",
    fill: "#4C831B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlineCheckTick);
export default __webpack_public_path__ + "static/media/icon-outline-check-tick.d973a8c2cd25b423f8965bb707882662.svg";
export { ForwardRef as ReactComponent };